import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { productQueryKeys } from "./productQueryKeys";

export function useMutationProductPicture({ api }: { api: ApiType }) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (payload: { productId: number; picture: Blob }) => {
      return await api.productApi.addPicture({
        id: payload.productId,
        picture: payload.picture,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: productQueryKeys.all() });
    },
  });
}
